// Ops › Tenants: one list with quick views at the top (TenantViews.tsx: All,
// Active, Signups, Ops trial, Past due, Suspended, Canceled, Deleted), told
// apart by the URL so each view and its filters can be linked to and reloaded.
// A signup is a tenant (owner, November 3): one list, one tenant page.
//
//   /tenants[?status=]       every tenant, or a paying status
//   /tenants?view=signups    the self-serve leagues that never paid, same list
//   /tenants?view=deleted    signups whose league was deleted (DeletedTenantsList)
//
// The old Signups tab (?tab=signups) and /signups links redirect here (App.tsx).

import { Navigate, useSearchParams } from 'react-router-dom'
import DeletedTenantsList from './DeletedTenantsList'
import TenantsListPage from './TenantsListPage'

export default function TenantsPage() {
  const [searchParams] = useSearchParams()
  if (searchParams.get('tab') === 'signups') {
    // The old Signups tab: its search carries over; its own filters were signup fields.
    const q = searchParams.get('q')
    return <Navigate to={`/tenants?view=signups${q ? `&q=${encodeURIComponent(q)}` : ''}`} replace />
  }
  return searchParams.get('view') === 'deleted' ? <DeletedTenantsList /> : <TenantsListPage />
}
